import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    RootRef,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { MenuFormType } from "../../../store/menu/forms";
import { localize } from "../../../../../common/libs";
import {
    MenuCategory,
} from "../../../../../services/menu/models";
import { DragDropContext, Draggable, Droppable, DropResult, ResponderProvided } from "react-beautiful-dnd";
import { AlignJustify as DragIcon, Edit2 as EditIcon, Trash as DeleteIcon } from "react-feather";
import { Typography } from "../../../../../common/components/libs";
import { SnackbarType } from "../../../../../stores/common";
import {Trans, useTranslation} from "react-i18next";

const getItemStyle = (isDragging, draggableStyle) => ({
    // styles we need to apply on draggables
    ...draggableStyle,
    padding: "10px 0px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "10px 5px",
    borderRadius: 5,

    ...(isDragging && {
        padding: "10px",
        background: "rgba(25, 118, 210, 0.1)"
    })
});


const EditMenuCategoriesForm = () => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const [categories, setCategories] = useState<MenuCategory[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const {i18n, t} = useTranslation(["general", "menu"]);


    const { menuStore, generalStore } = useStores();
    const { forms } = menuStore;
    const { open } = forms.forms[MenuFormType.editCategoriesForm];

    useEffect(() => {
        setCategories(menuStore.currentMenu.menuCategories || []);

    }, [menuStore.currentMenu]);


    const closeForm = () => {
        forms.closeForm(MenuFormType.editCategoriesForm)
    };


    const handleSubmit = async () => {
        setIsLoading(true);
        for(let item of categories){
            await menuStore.updateCategory(item.id, {
                isInStopList: item.data.isInStopList,
                workingSchedule: item.data.workingSchedule,
                name: item.data.name,
                sortOrder: item.data.sortOrder,
                parentMenuCategoryId: null,
                categoryCookingTime: item.data.categoryCookingTime,
            }, false);
        }
        await menuStore.reloadMenu();
        generalStore.showSnackbar({
            title: t("menu:menuEditor.categoryOrderChanged"),
            type: SnackbarType.success
        })
        setIsLoading(false);
        closeForm();
    };

    const reorder = (categories: MenuCategory[], startIndex: number, endIndex: number) => {
        const result = [...categories];
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result.map((item, index) => {
            return {
                ...item,
                data: {
                    ...item.data,
                    sortOrder: index
                }
            }
        });
    };

    const onDragEnd = (result: DropResult, provided: ResponderProvided) => {
        if (!result.destination) return;
        const newCategories = reorder(categories, result.source.index, result.destination.index);
        setCategories(newCategories);
    }


    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:menuEditor.editingCategories")}
            </DialogTitle>
            <DialogContent>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => {
                            return <RootRef rootRef={provided.innerRef}>
                                <List>
                                    {
                                        categories.map((category, index) => {
                                            return <Draggable key={category.id} draggableId={category.id.toString()}
                                                              index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style
                                                        )}
                                                    >
                                                        <div style={{display: "flex"}}>
                                                            <DragIcon size={20} color="#b5b5b5"/>
                                                            <Typography variant='h6' marginLeft={4}>
                                                                {localize(category.data.name)}
                                                            </Typography>
                                                        </div>
                                                        <div>
                                                            <EditIcon size={16}
                                                                onClick={() => {
                                                                    menuStore.forms.showPopupForm(
                                                                        MenuFormType.createMenuCategory,
                                                                        category
                                                                    )
                                                                }}
                                                            />
                                                            {/*<DeleteIcon size={16}/>*/}
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        })

                                    }
                                    {provided.placeholder}
                                </List>
                            </RootRef>
                        }}
                    </Droppable>
                </DragDropContext>
                {/*<FormControl fullWidth margin={"normal"}>
                    <InputLabel htmlFor="name">Название</InputLabel>
                    <Input
                        value={name}
                        onChange={changeEventHandlerDecorator(setName)}
                    />
                </FormControl>*/}
            </DialogContent>

            <DialogActions>
                <Button onClick={closeForm}
                        color="primary"
                        disabled={isLoading}
                >
                    {t("general:cancel")}
                </Button>
                <Button
                    color="primary"
                    onClick={handleSubmit}
                    disabled={isLoading}
                >
                    {t("general:save")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default observer(EditMenuCategoriesForm);
